// extracted by mini-css-extract-plugin
export default {"chat":"zhY3fDzS4psnlNQ6lMwA"};